import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import { IAnnouncement } from 'src/services/interfaces';
import store from 'src/services/redux/app/Store';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}`;
enum Status {
  loading = 'loading',
  done = 'done',
  fail = 'fail',
}

interface IState {
  status: Status | '';
  data: IAnnouncement | any;
  unRead: number;
  error: any;
}

interface IRequestParams {
  createdAtDateRange: string | any;
  page: number | any;
  limit: number | any;
}

const initialState: IState = {
  status: '',
  data: null,
  error: null,
  unRead: 0,
};

export const announcementList = createAsyncThunk('announcement/list', async (params: IRequestParams | any) => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  const res = await axios.get<IAnnouncement>(`${VENDOR_MC_URL}/${userId}/announcement/list`, { params });
  return res.data;
});

export const announcementRead = createAsyncThunk('announcement/read', async (id: any) => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  const res = await axios.get<any>(`${VENDOR_MC_URL}/${userId}/announcement/${id}/read`);
  return res.data;
});

export const announcementUnRead = createAsyncThunk('announcement/unread', async () => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  const res:any = userId ? await axios.get<any>(`${VENDOR_MC_URL}/${userId}/announcement/unread/count`) : null;
  return res?.data;
});

const announcementSlice = createSlice({
  name: 'announcement-list',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(announcementList.pending, (state, action) => {
      state.status = Status.loading;
    });
    builder.addCase(announcementList.fulfilled, (state, action) => {
      state.status = Status.done;
      state.data = action.payload;
    });
    builder.addCase(announcementList.rejected, (state, action) => {
      state.error = 'Duyurular ve operasyon mesajları listelenemedi!';
      state.status = Status.fail;
    });
    //
    builder.addCase(announcementRead.fulfilled, (state, action) => {
      var list = [...state.data?.items];
      var index = list.findIndex((e) => e.id === action.payload.id);
      list[index].isRead = true;
      if (state.unRead > 0) state.unRead = state.unRead - 1;
      state.data.items = list;
    });
    //
    builder.addCase(announcementUnRead.fulfilled, (state, action) => {
      state.status = Status.done;
      state.unRead = action.payload?.unReadCount;
    });
  },
});

export default announcementSlice.reducer;
